module.exports = {
	"root": "findify-components--breadcrumbs",
	"breadcrumb": "findify-components--breadcrumbs__breadcrumb",
	"title": "findify-components--breadcrumbs__title",
	"ball": "findify-components--breadcrumbs__ball",
	"cross": "findify-components--breadcrumbs__cross",
	"star": "findify-components--breadcrumbs__star",
	"unfilled": "findify-components--breadcrumbs__unfilled"
};